(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('projectCustomFieldsService', projectCustomFieldsService);

	projectCustomFieldsService.$inject = ['$http'];

	function projectCustomFieldsService($http) {
		var service = {
			getCustomFields: getCustomFields,
			addCustomField: addCustomField,
			updateCustomField: updateCustomField,
			deleteCustomField: deleteCustomField,
			getDropDownValues: getDropDownValues,
			addDropDownFieldValue: addDropDownFieldValue,
			updateDropDownFieldValue: updateDropDownFieldValue,
			deleteDropDownValue: deleteDropDownValue
		};
		return service;

		function getCustomFields(customerId) {
			return $http.get('/api/2/companyId/' + (customerId || globalConfig.customer.id) + '/LeanProject/CustomFields')
				.then(getCustomFieldsSuccess, handleError);

			function getCustomFieldsSuccess(response) {
				return response;
			}
		}
		
		function addCustomField(customField, customerId) {
			return $http.post('/api/2/companyId/' + (customerId || globalConfig.customer.id) + '/LeanProject/CustomFields', customField)
				.then(addCustomFieldsSuccess, handleError);

			function addCustomFieldsSuccess(response) {
				return 'Custom field created successfully';
			}
		}
		
		function updateCustomField(customField, lastModified, customerId) {			
			return $http.put('/api/2/companyId/' + (customerId || globalConfig.customer.id) + '/LeanProject/CustomFields', customField, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateCustomFieldSuccess, updateCustomFieldError);

			function updateCustomFieldSuccess(response) {
				return response;
			}

			function updateCustomFieldError(response) {
				return response;
			}
		}
		
		function deleteCustomField(fieldNdx, customerId) {
			return $http.delete('/api/2/companyId/' + (customerId || globalConfig.customer.id) + '/LeanProject/CustomField/' + fieldNdx)
			.then(deleteCustomFieldSuccess, handleError);

			function deleteCustomFieldSuccess(response) {
				return 'Custom field deleted successfully';
			}	
		}
		
		function getDropDownValues(customFieldNdx, customerId) {
			return $http.get('/api/2/companyId/' + (customerId || globalConfig.customer.id) + '/LeanProject/CustomDropDownField/' + customFieldNdx)
				.then(getDropDownValuesSuccess, handleError);

			function getDropDownValuesSuccess(response) {
				return response;
			}
		}
		
		function addDropDownFieldValue(customFieldNdx, dropDownField, customerId) {
			return $http.post('/api/2/companyId/' + (customerId || globalConfig.customer.id) + '/LeanProject/DropDownField/' + customFieldNdx, dropDownField)
			.then(addDropDownFieldValueSuccess, handleError);

			function addDropDownFieldValueSuccess(response) {
				return response;
			}
		}
		
		function updateDropDownFieldValue(customFieldNdx, dropDownField, customerId) {
			return $http.put('/api/2/companyId/' + (customerId || globalConfig.customer.id) + '/LeanProject/DropDownField/' + customFieldNdx, dropDownField)
			.then(updateDropDownFieldValueSuccess, handleError);

			function updateDropDownFieldValueSuccess(response) {
				return response;
			}		
		}
		
		function deleteDropDownValue(fieldNdx, customerId) {
			return $http.delete('/api/2/companyId/' + (customerId || globalConfig.customer.id) + '/LeanProject/DropDownField/DropDownFieldValue/' + fieldNdx)
			.then(deleteDropDownValueSuccess, handleError);

			function deleteDropDownValueSuccess(response) {
				return 'Custom field deleted successfully';
			}	
		}
		
		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 400 || error.status === 409 || error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
